"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10CommonComponents = require("r10-common-components");
var _r10SourceLibrary = require("r10-source-library");
var _reactRedux = require("react-redux");
var _selector = require("../../selectors/selector.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); } /*eslint-disable*/
var ActiveAddonsListing = function ActiveAddonsListing() {
  var activeAddonsList = (0, _reactRedux.useSelector)(_selector.activeAddonsMappedOptions);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !!activeAddonsList && /*#__PURE__*/_react.default.createElement("span", {
    "data-testid": "active-addons-list"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SimpleGrid, {
    verticalAlign: "stretch",
    justify: "left",
    spacing: 4
  }, activeAddonsList.map(function (addon) {
    return /*#__PURE__*/_react.default.createElement(_r10CommonComponents.AddonCard, _extends({
      key: addon.id
    }, addon));
  }))));
};
var _default = ActiveAddonsListing;
exports.default = _default;